import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCircleNotch } from 'react-icons/fa';



const Plan = ({ plan }) => {

  const { icon, image, title, content, price, features } = plan; // Extracting data from plan

  return (
    <div className="plan-item">

      <img src={image} alt={title} />

      <div className="plan-content">

        <div className="top">
          <h3>{title}</h3> {/* Plan Title */}
          <h5>{content}</h5> {/* Plan Content */}
        </div>

        <div className="icon-container">
          <div className='top-icon'>{icon}</div> {/* Dynamic Icon */}
        </div>

        <div className='content'>

          {/* List of Features */}
          <ul>
            {features.map((feature, index) => (
              <li key={index}><div className='icon'><FaCircleNotch /></div> {feature}</li> 
            ))}
          </ul>

          <div className='price-box'>
            <div className="price">${price}</div> {/* Plan Price */}
            <p>/ month</p>
          </div>

          <Button link={"Get-Quote"} title={"Get Started"} />

        </div>

      </div>

    </div>
  );
};

export default Plan;